// src/App.js
import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Header from './Header';
import ProfessionalReport from './ProfessionalReport';
import PaletProductionReport from './PaletProductionReport';
import MecaProductionReport from './MecaProductionReport';
import DailyProductionReport from './DailyProductionReport';
import { StockSearch, StockSearchPla, StockSearchFil } from './StockSearch';
import FichajePanel from './FichajePanel';

import './App.css'; // Estilos globales

function MainApp() {
  return (
    <Router>
      <Header />
      <div className="main-content">
        <Routes>
          <Route path="/" element={<ProfessionalReport />} />
          <Route path="/palet-production" element={<PaletProductionReport />} />
          <Route path="/meca-production" element={<MecaProductionReport />} />
          <Route path="/loquesea" element={<StockSearch />} />
          <Route path="/stock-search-pla" element={<StockSearchPla />} />
          <Route path="/stock-search-fil" element={<StockSearchFil />} />
          <Route path="/leandro" element={<DailyProductionReport />} />
          <Route path="/fichar" element={<FichajePanel />} />

          {/* Agrega más rutas aquí si tienes más vistas */}
        </Routes>
      </div>
    </Router>
  );
}

export default MainApp;
